module.exports = __webpack_public_path__ + "static/media/onboarding8desktop.47681e06.svg";